import { useApplicationContext } from '../../providers/ApplicationProvider/ApplicationProvider';

/**
 * useConfig
 *
 * Custom hook to give quick access to the config object
 *
 * @returns
 */
export const useConfig = () => {
    const { config } = useApplicationContext();

    return config;
};
